import React from 'react';
import { Modal } from './Modal';

export const withModal = <P,>(wrappedComponent: React.ComponentType<P>) => {
  return (props: P) => <Modal {...props} component={wrappedComponent} open />;
};
